import { Box, Button, FormControl, FormHelperText, Grid, TextField, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useContext, useEffect, useState } from 'react';
import EmailCampaignService from '../../../../modules/survey/shared-services/email-campaign/email-campaign.service';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { useIsReportPeriodLocked } from '../../../../hooks/use-is-report-period-locked';

export const EmissionsEmailCampaignReviewForm = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  //Services
  const emailCampaignService = new EmailCampaignService();
  const userNotificationsContext = useContext(UserNotificationsContext);
  //Hooks
  const isReportPeriodLocked = useIsReportPeriodLocked()
  //State
  const [campaignId, setCampaignId] = useState<string>();

  //Use Effects
  useEffect(() => {
    if (searchParams.has('campaignId')) {
      const id = searchParams.get('campaignId')
      if (id) {
        setCampaignId(id)
      }
    }
  }, [searchParams])

  const testEmailSchema = Yup.object().shape({
    email: Yup.string().email('Email is invalid').required('Email is required'),
  })

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: testEmailSchema,
    onSubmit: (values) => {
      if (isReportPeriodLocked) {
        userNotificationsContext.openDialog({ active: true, title: 'Action Not Allowed', message: `The selected report period is locked and cannot be modified`, buttonCopy: 'Ok', hideCancelButton: true })
      } else {
        emailCampaignService.sendTestEmail(campaignId!, values.email)
          .then(() => {
            userNotificationsContext.openSnackbar({ open: true, message: `Email sent, please check your inbox` });
            formik.resetForm();
          })
          .catch((err) => {
            console.log(err)
            if (err.response.data.code === 1) {
              userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
            } else {
              userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
            }
          })
      }
    }
  });
  return (
    <Box component='form' onSubmit={formik.handleSubmit}>
      <FormControl fullWidth variant='outlined'>
        <Grid container spacing={4}>
          <Grid item xs={9} md={9} lg={9}>
            <TextField id='email' label='Email address' name='email' type='email'
              placeholder='Email address'
              onChange={formik.handleChange}
              fullWidth
              value={formik.values.email}
              error={formik.touched.email && Boolean(formik.errors.email)}
            />
          </Grid>
          <Grid item xs={3} md={3} lg={3}>
            <Button sx={{ height: '100%', width: '100%' }} variant='outlined' type='submit'>
              <Typography>Send Test Email</Typography>
            </Button>
          </Grid>
        </Grid>
        {formik.touched.email && formik.errors.email &&
          <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
            {formik.errors.email ? <div>{formik.errors.email as string}</div> : null}
          </FormHelperText>}
      </FormControl>
    </Box>
  )
}